import { classNames } from "@circle-react/helpers/twMergeWithCN";
import { Icon } from "@circleco/compass/components/Icon";
import { Popover } from "@circleco/compass/components/Popover";
import { useCallback, useState } from "react";

import { t } from "@/i18n-js/instance";
import { useWindowResize } from "@/react/hooks/utils/useWindowResize";

import {
  NAV_LINK_ACTIVE_CLASSES,
  NAV_LINK_INTERACTIVE_CLASSES,
  NavigationLink,
} from "./NavigationLink";
import type { NavigationLinkData } from "./types";

interface MorePopoverProps {
  isPreviewMode?: boolean;
  items: NavigationLinkData[];
}

export const MorePopover = ({
  items,
  isPreviewMode = false,
}: MorePopoverProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const closeOnResize = useCallback(() => {
    setIsOpen(false);
  }, []);
  useWindowResize(closeOnResize);

  return (
    <Popover
      trigger={
        <button
          type="button"
          disabled={isPreviewMode}
          className={classNames(NAV_LINK_INTERACTIVE_CLASSES, {
            [NAV_LINK_ACTIVE_CLASSES]: isOpen,
          })}
        >
          <span className="flex items-center gap-0.5">
            {t("header_v3.navigation.more")}
            <Icon name="chevron-down" size="sm" aria-hidden="true" />
          </span>
        </button>
      }
      open={isOpen}
      onOpenChange={setIsOpen}
      side="bottom"
      align="end"
      className="p-0"
    >
      <div className="flex flex-col gap-1 rounded-md bg-c-header p-4 outline-none">
        {items.map(({ linkTo, label, kind, visibility, openInNewWindow }) => (
          <NavigationLink
            key={linkTo}
            label={label}
            linkTo={linkTo}
            isActive={false}
            onClick={() => setIsOpen(false)}
            kind={kind}
            visibility={visibility}
            openInNewWindow={openInNewWindow}
          />
        ))}
      </div>
    </Popover>
  );
};
